import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/xuxun/Documents/projects/xx/antd-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "typescript-docz-example"
    }}>{`Typescript Docz example`}</h1>
    <h2 {...{
      "id": "功能概览"
    }}>{`功能概览`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`名称`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`方法名`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`demo`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`稳定版本`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`表格转置`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`transformTable`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Table`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-transform-table"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`复制 tags`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`pasteTags`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Select`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-paste-tags"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`TS 枚举转 select options`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`enum2Options`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Select`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-transform-table"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`获取 url 参数`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`getQueryString`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Utils`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-get-querystring/"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.9`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`纵向合并相邻重复单元格`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`calcRowspanToMerge`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Table`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-calc-rowspan-to-merge/"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.11`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`页面进入或离开触发回调函数`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`handleVisibilityChange`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Utils`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://xunge0613.github.io/antd-utils/demo/src-demos-handle-visibility-change/"
            }}>{`文档`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.1.14`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "setup"
    }}>{`Setup`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn # npm i
`}</code></pre>
    <h2 {...{
      "id": "run"
    }}>{`Run`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn dev # npm run dev
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      